import { AuthScreen } from './AuthScreen';

/** PostgREST answered PGRST106: schema `seo` is not in the project's exposed schemas yet. */
export default function SchemaNotExposed() {
  return (
    <AuthScreen title="The seo schema is not exposed yet">
      <p>The database is set up, but its API cannot see the SEO HQ tables. This is a one-time setting.</p>
      <div className="asktxt">Supabase → Project Settings → API → Exposed schemas → add seo</div>
      <p className="mut">Save, wait a few seconds, then reload this page.</p>
      <button type="button" className="btn primary" onClick={() => window.location.reload()}>
        Reload
      </button>
    </AuthScreen>
  );
}
